import { EmployeeIdentificationType } from '@fora-monorepo/employer-my-pages-common/types';

import { validateEmployeeCoordinationNumber, validateEmployeePin } from '../../common/utils';

export const getIDValidator = (employeeIDType: EmployeeIdentificationType | string) => {
  if (employeeIDType === EmployeeIdentificationType.PersonalIdentityNumber) {
    return validateEmployeePin;
  }
  if (employeeIDType === EmployeeIdentificationType.CoOrdinationNumber) {
    return validateEmployeeCoordinationNumber;
  }
  return validateEmployeePin;
};
